<script setup lang="ts">
import merge from 'lodash-es/merge';

defineOptions({
    name: 'WkNewsletterSettings'
});

const emit = defineEmits<{
    (e: 'update:modelValue',): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const module = ref<string>('wk-subscriptions');
const defaults = ref<any>({
    querystring: null,
    newsletterPageId: null
});

const form = computed<any>(() =>
{
    return props.modelValue;
});

watch(() => form.value.settings, () =>
{
    triggerModel();
},
{ deep: true });

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

async function validate(): Promise<void>
{
    form.value.validate(schema => ({
        settings: schema.object({
            newsletterPageId: schema.number().nullable()
                .required($t('[[[Wybieranie strony jest wymagane]]]'))
                .typeError($t('[[[Wybieranie strony jest wymagane]]]'))
        })
    }));
}
onBeforeMount((): void =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});

defineExpose({
    validate
});
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Query string]]]')" :invalid-feedback="form.$errors.first('settings.querystring')" :state="form.$errors.state('settings.querystring')" required>
        <IdeoFormInput v-model="form.settings.querystring" type="text" name="querystring" />
    </IdeoFormGroup>

    <IdeoFormGroup :label="$t('[[[Wybór strony]]]')" :invalid-feedback="form.$errors.first('settings.newsletterPageId')" :state="form.$errors.state('settings.newsletterPageId')" required>
        <EditoPageSelector v-model="form.settings.newsletterPageId" :module="module" label="" :preview="false" class="mb-0" />
    </IdeoFormGroup>
</template>
